import {API} from '../../networking/http'
import {QueryMethod} from '../helpers/types'
import {TerminalData} from './types'

export type GetTerminalParams = {
  userId?: string
  venueId?: string
}
export type GetTerminalQueryParams = undefined
export type GetTerminalQueryReturnType = TerminalData | null
export type GetTerminalQuery = QueryMethod<GetTerminalParams, GetTerminalParams, GetTerminalQueryReturnType>

export const terminalEndpoint = 'payments/terminalName'

export const getTerminalQuery: GetTerminalQuery = ({params, ...rest}) => {
  return {
    queryKey: ['getTerminalQuery', params],
    cacheTime: 1000 * 10,
    refetchOnWindowFocus: false,
    ...rest,
    queryFn: () => {
      if (!params?.venueId) {
        return Promise.resolve(null)
      }
      return API.get<GetTerminalQueryParams, GetTerminalQueryReturnType>(terminalEndpoint, {
        params,
      }).then((res) => res.data)
    },
  }
}
